import config from "@/config";

export default async function log() {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/runtime/runtime");
    m["LogTrace"](JSON.stringify(arguments));
  } else {
    console.log(JSON.stringify(arguments));
  }
}



// WEBPACK FOOTER //
// ./src/logger.js